export const flowerMeaningsByColor = { 
  "Đỏ": { 
    meaning: "Những bông hoa tươi mang màu đỏ rực rỡ, màu của đam mê, nhiệt huyết, màu đỏ của trái tim nóng.", 
    flowers: [ 
      { 
        id: "red-1", 
        name: "Hồng Đỏ Ecuador", 
        image: "flower14.webp", 
        price: 1000000, 
        description: "Biểu tượng của tình yêu nồng cháy và không bao giờ lụi tàn", 
        meanings: [ 
          { color: "Đỏ", meaning: "Những bông hoa tươi mang màu đỏ rực rỡ, màu của đam mê, nhiệt huyết." }, 
          { color: "Vàng", meaning: "Ý nghĩa màu hoa vàng thường gắn với sự tươi sáng, khởi đầu mới." } 
        ] 
      }, 
      { 
        id: "red-2", 
        name: "Hồng Đỏ Thường", 
        image: "flower15.webp", 
        price: 800000, 
        description: "Màu đỏ truyền thống tượng trưng cho tình yêu chân thành", 
        meanings: [ 
          { color: "Đỏ", meaning: "Những bông hoa tươi mang màu đỏ rực rỡ, màu của đam mê, nhiệt huyết." } 
        ] 
      } 
    ] 
  }, 
  "Hồng": { 
    meaning: "Giống như những bông hoa màu đỏ, những bông hoa màu hồng cũng mang ý nghĩa lãng mạn.", 
    flowers: [ 
      { 
        id: "pink-1", 
        name: "Hồng Phấn", 
        image: "flower23.webp", 
        price: 520000, 
        description: "Sắc hồng nhạt dịu dàng, thể hiện sự ngưỡng mộ và lời chúc ấm áp", 
        meanings: [ 
          { color: "Hồng", meaning: "Giống như những bông hoa màu đỏ, những bông hoa màu hồng cũng mang ý nghĩa lãng mạn." }, 
          { color: "Trắng", meaning: "Sắc màu của sự tinh khiết, ngây thơ, tượng trưng cho một sự bắt đầu." } 
        ] 
      }, 
      { 
        id: "pink-2", 
        name: "Hồng Hồng Ecuador", 
        image: "flower17.webp", 
        price: 1300000, 
        description: "Sắc hồng nồng nàn, luôn tươi mới và đong đầy cảm xúc", 
        meanings: [ 
          { color: "Hồng", meaning: "Giống như những bông hoa màu đỏ, những bông hoa màu hồng cũng mang ý nghĩa lãng mạn." } 
        ] 
      } 
    ] 
  }, 
  "Trắng": { 
    meaning: "Sắc màu của sự tinh khiết, ngây thơ, tượng trưng cho một sự bắt đầu.", 
    flowers: [ 
      { 
        id: "white-1", 
        name: "Hồng Trắng Cồ", 
        image: "flower11.webp", 
        price: 600000, 
        description: "Trắng tinh khôi, biểu tượng của sự gắn kết bền bỉ", 
        meanings: [ 
          { color: "Trắng", meaning: "Sắc màu của sự tinh khiết, ngây thơ, tượng trưng cho một sự bắt đầu." } 
        ] 
      }, 
      { 
        id: "white-2", 
        name: "Cúc Trắng", 
        image: "flower31.webp", 
        price: 600000, 
        description: "Sắc trắng thanh tịnh, là sự đồng hành lặng lẽ nhưng đầy ý nghĩa", 
        meanings: [ 
          { color: "Trắng", meaning: "Sắc màu của sự tinh khiết, ngây thơ, tượng trưng cho một sự bắt đầu." }, 
          { color: "Xanh Dương", meaning: "Màu hoa theo tâm trạng mang tính cá nhân cao, trong đó màu xanh là màu của sự bình yên." } 
        ] 
      } 
    ] 
  }, 
  "Vàng": { 
    meaning: "Ý nghĩa màu hoa vàng thường gắn với sự tươi sáng, khởi đầu mới, và thành tựu.", 
    flowers: [ 
      { 
        id: "yellow-1", 
        name: "Hướng Dương", 
        image: "flower25.webp", 
        price: 750000, 
        description: "Tượng trưng của sự thịnh vượng và khởi đầu rực rỡ", 
        meanings: [ 
          { color: "Vàng", meaning: "Ý nghĩa màu hoa vàng thường gắn với sự tươi sáng, khởi đầu mới, và thành tựu." }, 
          { color: "Xanh Dương", meaning: "Màu hoa theo tâm trạng mang tính cá nhân cao, trong đó màu xanh là màu của sự bình yên." } 
        ] 
      }, 
      { 
        id: "yellow-2", 
        name: "Hoa Ly Vàng", 
        image: "flower25.webp", 
        price: 550000, 
        description: "Hoa ly vàng sang trọng mang ý nghĩa về sự phát triển", 
        meanings: [ 
          { color: "Vàng", meaning: "Ý nghĩa màu hoa vàng thường gắn với sự tươi sáng, khởi đầu mới, và thành tựu." } 
        ] 
      } 
    ] 
  }, 
  "Xanh Dương": { 
    meaning: "Màu hoa theo tâm trạng mang tính cá nhân cao, trong đó màu xanh là màu của sự bình yên.", 
    flowers: [ 
      { 
        id: "blue-1", 
        name: "Cẩm Tú Cầu Xanh", 
        image: "flower7.webp", 
        price: 180000, 
        description: "Sắc xanh dịu mắt, biểu tượng của sự bền chặt", 
        meanings: [ 
          { color: "Xanh Dương", meaning: "Màu hoa theo tâm trạng mang tính cá nhân cao, trong đó màu xanh là màu của sự bình yên." }, 
          { color: "Trắng", meaning: "Sắc màu của sự tinh khiết, ngây thơ, tượng trưng cho một sự bắt đầu." } 
        ] 
      } 
    ] 
  }, 
  "Cam": { 
    meaning: "Năng lượng, nhiệt huyết, sáng tạo", 
    flowers: [ 
      { 
        id: "orange-1", 
        name: "Hồng Cam Ecuador", 
        image: "flower29.webp", 
        price: 1400000, 
        description: "Sắc cam rực rỡ, mang năng lượng của mặt trời", 
        meanings: [ 
          { color: "Cam", meaning: "Năng lượng, nhiệt huyết, sáng tạo" }, 
          { color: "Vàng", meaning: "Ý nghĩa màu hoa vàng thường gắn với sự tươi sáng, khởi đầu mới." } 
        ] 
      } 
    ] 
  }, 
  "Tím": { 
    meaning: "Một màu sắc vô cùng quyến rũ, nhẹ nhàng mà lại rất bí ẩn.", 
    flowers: [ 
      { 
        id: "purple-1", 
        name: "Cẩm Chướng Tím", 
        image: "flower41.webp", 
        price: 750000, 
        description: "Sắc tím huyền bí như những vì sao sáng", 
        meanings: [ 
          { color: "Tím", meaning: "Một màu sắc vô cùng quyến rũ, nhẹ nhàng mà lại rất bí ẩn." }, 
          { color: "Trắng", meaning: "Sắc màu của sự tinh khiết, ngây thơ, tượng trưng cho một sự bắt đầu." } 
        ] 
      } 
    ] 
  } 
}; 

export const flowerMeaningsByType = { 
  "Hoa hồng": { 
    description: "Vua của những bông hoa, hoa hồng tượng trưng cho tình yêu và sự lãng mạn", 
    flowers: [ 
      { 
        id: "rose-1", 
        name: "Hồng Đỏ Ecuador", 
        image: "flower14.webp", 
        price: 1000000, 
        description: "Biểu tượng của tình yêu nồng cháy và không bao giờ lụi tàn", 
        colorMeanings: [ 
          { color: "Đỏ", meaning: "Những bông hoa tươi mang màu đỏ rực rỡ, màu của đam mê, nhiệt huyết." }, 
          { color: "Vàng", meaning: "Ý nghĩa màu hoa vàng thường gắn với sự tươi sáng, khởi đầu mới." } 
        ] 
      }, 
      { 
        id: "rose-2", 
        name: "Hồng Phấn", 
        image: "flower23.webp", 
        price: 520000, 
        description: "Sắc hồng nhạt dịu dàng, thể hiện sự ngưỡng mộ", 
        colorMeanings: [ 
          { color: "Hồng", meaning: "Giống như những bông hoa màu đỏ, những bông hoa màu hồng cũng mang ý nghĩa lãng mạn." }, 
          { color: "Trắng", meaning: "Sắc màu của sự tinh khiết, ngây thơ, tượng trưng cho một sự bắt đầu." } 
        ] 
      } 
    ] 
  }, 
  "Hoa cẩm tú cầu": { 
    description: "Hoa tuyệt diệu với vẻ đẹp tròn đầy, tượng trưng cho tình yêu thuần khiết", 
    flowers: [ 
      { 
        id: "hydrangea-1", 
        name: "Cẩm Tú Cầu Xanh", 
        image: "flower7.webp", 
        price: 180000, 
        description: "Sắc xanh dịu mắt, biểu tượng của sự bền chặt", 
        colorMeanings: [ 
          { color: "Xanh Dương", meaning: "Màu hoa theo tâm trạng mang tính cá nhân cao, trong đó màu xanh là màu của sự bình yên." }, 
          { color: "Trắng", meaning: "Sắc màu của sự tinh khiết, ngây thơ, tượng trưng cho một sự bắt đầu." } 
        ] 
      } 
    ] 
  }, 
  "Hoa hướng dương": { 
    description: "Hoa tượng trưng cho sự lạc quan, sự may mắn và năng lượng tích cực", 
    flowers: [ 
      { 
        id: "sunflower-1", 
        name: "Hướng Dương", 
        image: "flower25.webp", 
        price: 750000, 
        description: "Tượng trưng của sự thịnh vượng và khởi đầu rực rỡ", 
        colorMeanings: [ 
          { color: "Vàng", meaning: "Ý nghĩa màu hoa vàng thường gắn với sự tươi sáng, khởi đầu mới, và thành tựu." }, 
          { color: "Xanh Dương", meaning: "Màu hoa theo tâm trạng mang tính cá nhân cao, trong đó màu xanh là màu của sự bình yên." } 
        ] 
      } 
    ] 
  } 
}; 

export const colorMeanings = { 
  "Đỏ": `Những bông hoa tươi mang màu đỏ rực rỡ, màu của đam mê, nhiệt huyết, màu đỏ của trái tim nóng. Một bó hoa màu đỏ là cách để truyền đi thông điệp về một tình yêu mãnh liệt, nồng cháy, đầy quyến rũ và đam mê.

Nhắc đến hoa màu đỏ, chúng ta nhớ ngay đến hoa hồng, một biểu tượng khổng lồ cho tình yêu đôi lứa. Ngoài ra hoa cẩm chướng, hoa cúc đỏ cũng truyền đạt những ý nghĩa tương tự.

Thích hợp cho: Người yêu, vợ/chồng trong ngày kỷ niệm, Valentine, hoặc dịp cầu hôn.`,

  "Hồng": `Giống như những bông hoa màu đỏ, những bông hoa màu hồng cũng mang ý nghĩa lãng mạn, tuy không mãnh liệt như những bông hoa màu đỏ, nhưng những bông hoa màu hồng mang đến cho chúng ta một cảm giác bình yên, một hạnh phúc giản dị và bền lâu. Hoa màu hồng cũng mang đến cho người nhận sự dịu dàng, nữ tính, một chút ngây thơ trong sáng và một chút tinh tế.

Thích hợp cho: Bạn gái mới quen, mẹ, chị em hoặc đồng nghiệp nữ.`,

  "Trắng": `Sắc màu của sự tinh khiết, ngây thơ, là một màu sắc tượng trưng cho một sự bắt đầu, sự khởi đầu mới. Những bông hoa màu trắng, màu của sự hoàn hảo thể hiện sự trong trắng, trung thực. Đây là những bông hoa lý tưởng để bạn có thể truyền đạt thông điệp khi phối hợp với những loại hoa khác.

Với nhiều người, đặc biệt là ở phương Tây, màu trắng là màu tuyệt vời dành cho hoa cưới cầm tay cô dâu, cho một đám cưới màu trắng hoàn hảo. Đó chính là khởi đầu mới trong cuộc sống hạnh phúc của đôi bạn trẻ, tượng trưng cho một tình yêu thuần khiết.

Nếu bạn đang trong giai đoạn yêu đương, một bó hoa màu trắng là cách để bạn thể hiện sự nghiêm túc của mình, bạn muốn tiến xa hơn trong mối quan hệ này và suy nghĩ về một cuộc hôn nhân. Hãy thử với những bó hoa cẩm chướng, hoa hồng, hồng Lily, hoa phong lan, hay hoa cúc nhé.`,

  "Vàng": `Ý nghĩa màu hoa vàng thường gắn với sự tươi sáng, khởi đầu mới, và thành tựu. Đây là một trong những màu hoa theo tâm trạng tích cực nhất.

Thích hợp cho: Dịp khai trương, tốt nghiệp hoặc chúc mừng thành công.`,

  "Xanh Dương": `Màu hoa theo tâm trạng mang tính cá nhân cao, trong đó màu xanh là màu của sự bình yên, niềm tin và sáng tạo. Hiếm thấy nhưng đặc biệt phù hợp với những người cá tính, nghệ sĩ hoặc yêu sự mới mẻ. 

Bên cạnh đó, hoa màu xanh dương còn mang ý nghĩa về sự hy vọng, niềm tin vững chắc và sự trung thành trong các mối quan hệ. Vẻ đẹp hiếm có, huyền biến của chúng đại diện cho những giấc mơ, sự chân thành và khao khát vươn xa, phù hợp làm quà tặng đặc biệt, tạo cảm giác thư giãn, nhẹ nhàng.`,

  "Cam": `Mang lại năng lượng của sự nhiệt huyết, sáng tạo và sự vui tươi ngập tràn.`,

  "Tím": `Một màu sắc vô cùng quyến rũ, nhẹ nhàng mà lại rất bí ẩn. Màu tím tượng trưng cho sự quyến rũ, ân sủng, sự sang trọng, tôn trọng tuyệt đối. 

Hoa màu tím cho thấy một cử chỉ lãng mạn, cảm giác thanh lịch, dịu dàng, là cách để bạn thể hiện cảm xúc của mình. Bó hoa màu tím là món quà thể hiện được cảm xúc yêu ngay từ cái nhìn đầu tiên. Những bông hoa màu tím là một trong những màu hoa đẹp nhất.`,

  "Xanh Lá": `Thường rất ít gặp những bông hoa màu xanh lá cây. Những bông hoa màu xanh lá cây là một sự hòa hợp tuyệt vời với thiên nhiên, là khát vọng của tuổi trẻ, sự kiên cường. 

Màu xanh lá cây cũng là màu của tiền tài, sức khỏe, màu của sự thịnh vượng. Hãy tặng cho ai đó một những bông hoa màu xanh lá cây để mang lại nhiều may mắn cho họ, là lời động viên họ vượt qua những khó khăn hiện tại.`,
 
};